import Mention from '@tiptap/extension-mention';
import type { EditorView } from '@tiptap/pm/view';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { createTipTapDragDropPlugin } from '@/app/utils/client';
import MentionNodeView from '../components/MentionNodeView';
import { createCustomSuggestionPlugin } from './custom-suggestion';

/**
 * 自定义Mention扩展
 * 基于Tiptap的Mention扩展，增加了拖拽功能和 color 属性;
 * 使用自定义的 suggestion 插件
 */
export const CustomMention = Mention.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      showTooltip: false, // 默认值
      className: '', // 允许业务侧覆盖 mention 节点样式
      variant: 'default' as 'default' | 'media-chip',
    };
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      color: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-color'),
        renderHTML: (attributes) => {
          return {
            'data-color': attributes.color,
          };
        },
      },
      preview: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-preview'),
        renderHTML: (attributes) => {
          return {
            'data-preview': attributes.preview,
          };
        },
      },
      mediaType: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-media-type'),
        renderHTML: (attributes) => {
          return {
            'data-media-type': attributes.mediaType,
          };
        },
      },
    };
  },
  draggable: true,
  // 在节点视图中访问配置
  addNodeView() {
    return ReactNodeViewRenderer(MentionNodeView);
  },
  addKeyboardShortcuts() {
    const parent = this.parent?.() ?? {};
    return {
      ...parent,
      Backspace: (...args: Parameters<typeof parent.Backspace>) => {
        const view = this.editor.view as EditorView & { dragging?: unknown | null };
        if (view.dragging) return true; // 拖拽中不处理 Backspace 键，避免报错：https://trace.shengshu-ai.com/organizations/sentry/issues/24495/?project=10
        return parent.Backspace?.(...args) ?? false; // 其他情况走官方逻辑
      },
    };
  },
  addProseMirrorPlugins() {
    // 使用自定义的 suggestion 插件替换默认的 suggestion 插件（参考https://github.com/ueberdosis/tiptap/blob/main/packages/extension-mention/src/mention.ts#L261）
    const plugins = [
      createCustomSuggestionPlugin({ editor: this.editor, ...this.options.suggestion }),
      createTipTapDragDropPlugin({ nodeClassName: 'node-mention' }),
    ];

    return plugins;
  },
});
